module.exports = __webpack_public_path__ + "img/logo-mark.b93f70aa.png";